import { useTheme, type Theme } from '@/lib/theme/theme-context';

const OPTIONS: { theme: Theme; glyph: string; label: string }[] = [
  { theme: 'dark', glyph: '◐', label: 'Dark theme' },
  { theme: 'light', glyph: '☀', label: 'Light theme' },
];

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  return (
    <div
      role="group"
      aria-label="Colour theme"
      className="border-bd bg-elev flex h-8 flex-none items-center rounded-2xl border p-0.5"
    >
      {OPTIONS.map((option) => {
        const active = theme === option.theme;
        return (
          <button
            key={option.theme}
            type="button"
            onClick={() => setTheme(option.theme)}
            aria-pressed={active}
            title={option.label}
            className="grid size-[26px] place-items-center rounded-[13px] font-mono text-[11px] transition-colors"
            style={{
              background: active ? 'var(--high)' : 'transparent',
              color: active ? 'var(--tx)' : 'var(--tx3)',
            }}
          >
            <span aria-hidden>{option.glyph}</span>
            <span className="sr-only">{option.label}</span>
          </button>
        );
      })}
    </div>
  );
}
